import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';
import { PageTypeRolesBlock } from '../../_blocks/PageTypeRoles';
import { isNullOrUndefined } from '../../lib/typeGuards';

export type PageTypeRolesWidget = WidgetShape<PageTypeRolesBlock, WidgetType.pagetyperoles>;

export function PageTypeRolesWidget({ blocks, elementType, ...headerProps }: PageTypeRolesWidget) {
  const { t } = useSonTranslation('PageTypeRoles');

  if (!blocks || blocks.length === 0 || isNullOrUndefined(blocks[0]) || isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.SETTINGS}
      title={t('widgetTitle')}
    >
      {blocks[0] && <PageTypeRolesBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
